(function () {
  'use strict';

  if (!customElements.get('cro-course-selector')) {
  const initializedProducts = new WeakSet();

  class CroCourseSelector extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.productRoot = this.closest('product-info');
      this.liveRegion = this.querySelector('[data-cro-course-status]');
      this.inputs = Array.from(this.querySelectorAll('[data-cro-course-input]'));
      this.initialActiveVariantId = Number(this.dataset.activeVariantId);
      this.currentVariantId = Number(this.dataset.currentVariantId);

      this.onChange = this.onChange.bind(this);

      this.inputs.forEach((input) => input.addEventListener('change', this.onChange));
      // Wait for the native custom elements before dispatching a variant change.
      Promise.all([customElements.whenDefined('product-info'), customElements.whenDefined('variant-selects')])
        .then(() => requestAnimationFrame(() => {
          if (this.isConnected) this.initializeSelection();
        }));
    }

    disconnectedCallback() {
      this.inputs?.forEach((input) => input.removeEventListener('change', this.onChange));
      this.initialized = false;
    }

    onChange(event) {
      if (!event.target.checked) return;
      const label = event.target.dataset.courseLabel || event.target.value;
      if (this.liveRegion) this.liveRegion.textContent = `${label} selected`;

      this.dispatchEvent(
        new CustomEvent('cro:course:select', {
          bubbles: true,
          detail: {
            productId: Number(this.dataset.productId),
            variantId: Number(event.target.dataset.variantId),
            course: label,
          },
        })
      );
    }

    initializeSelection() {
      if (!this.inputs.length || !this.productRoot || initializedProducts.has(this.productRoot)) return;
      // Native variant updates replace this selector. Apply the configured default
      // only once per product-info instance, never after a user changes their course.
      initializedProducts.add(this.productRoot);
      if (this.dataset.explicitVariantId) return;
      const requestedVariantId = this.initialActiveVariantId;
      let selectedInput = this.inputs.find(
        (input) => Number(input.dataset.variantId) === requestedVariantId && !input.disabled
      );

      if (!selectedInput) {
        selectedInput = this.inputs.find((input) => input.checked && !input.disabled);
      }

      if (!selectedInput) {
        selectedInput = this.inputs.find((input) => !input.disabled);
      }

      if (!selectedInput) return;
      selectedInput.checked = true;

      if (Number(selectedInput.dataset.variantId) !== this.currentVariantId) {
        selectedInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

  }

    customElements.define('cro-course-selector', CroCourseSelector);
  }

  if (!customElements.get('cro-gallery-carousel')) {
    class CroGalleryCarousel extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('[data-carousel-track]');
        this.previousButton = this.querySelector('[data-carousel-previous]');
        this.nextButton = this.querySelector('[data-carousel-next]');

        if (!this.track) return;

        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.updateButtons = this.updateButtons.bind(this);

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.track.addEventListener('scroll', this.updateButtons, { passive: true });
        window.addEventListener('resize', this.updateButtons);
        this.resizeObserver = new ResizeObserver(this.updateButtons);
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(this.updateButtons);
      }

      disconnectedCallback() {
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.track?.removeEventListener('scroll', this.updateButtons);
        window.removeEventListener('resize', this.updateButtons);
        this.resizeObserver?.disconnect();
        this.initialized = false;
      }

      move(direction) {
        this.track.scrollBy({
          left: direction * Math.max(this.track.clientWidth * 0.85, 180),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        });
      }

      updateButtons() {
        if (!this.track) return;
        const maximumScroll = this.track.scrollWidth - this.track.clientWidth;
        if (this.previousButton) this.previousButton.disabled = this.track.scrollLeft <= 2;
        if (this.nextButton) this.nextButton.disabled = this.track.scrollLeft >= maximumScroll - 2;
      }
    }

    customElements.define('cro-gallery-carousel', CroGalleryCarousel);
  }
})();
